import {EventEmitter, Injectable} from '@angular/core';
import {IPlatformToolHandler} from '@shared/components/platform-tool/platform-tool-container/platform-tool-component';
import {InvalidateSubject} from '@shared/helpers/invalidate.subject';
import {MagicLinkModel, TabModel} from '@shared/models/platform-tool-models';
import {PlatformCommand} from '@shared/commands/command-base';
import {take} from 'rxjs/operators';
import {RootDynamicComponentHelper} from '@shared/helpers/root-dynamic-component-helper';
import {select} from '@ngrx/store';
import {getCurrentFilterId} from '@shared/store/selectors/conceptual-graph.selectors';
import {CommandService} from '@core/services/command.service';
import {FuseSplashScreenService} from '@barebone-fuse-services/splash-screen.service';
import {Router} from '@angular/router';
import {FileManagementService} from '@core/services/file-management.service';
import {SnackBarService} from '@core/services/snack-bar.service';

@Injectable({
  providedIn: 'root',
})
export class FieldSchemaHandler implements IPlatformToolHandler {
  invalidateSubject: InvalidateSubject;
  magicLinkModel: MagicLinkModel;
  magicLinkModelValueChanged: EventEmitter<any> = new EventEmitter();

  constructor(private commandService: CommandService,
              private fileManagementService: FileManagementService,
              private snackBarService: SnackBarService,
              private fuseSplashScreenService: FuseSplashScreenService,
              private router: Router) {
  }

  destroy(): void {
  }

  executeCommand(command: PlatformCommand, callBack?: any) {
    if (command.fieldValues['CommandHandler'] && command.fieldValues['CommandHandler'] !== 'FieldSchemaHandler') {
      const commandHandler = RootDynamicComponentHelper.getComponent(command.fieldValues['CommandHandler']);
      if (commandHandler) {
        commandHandler.executeCommand(command, this, null);
        return;
      }
    }
    switch (command.name) {
      default:
        this.executeCommandToApi(command);
        break;
    }
  }

  private executeCommandToApi(command: PlatformCommand) {
    if (command.api && command.api.length > 0 && !command.isDisabled) {
      this.fuseSplashScreenService.show();
      this.commandService.executePlatformCommand(command).pipe(take(1)).subscribe(commandResponse => {
          if (commandResponse.fieldValues['DownloadFileResponseModel']) {
            const downloadResponseModel = commandResponse.fieldValues['DownloadFileResponseModel'];
            const fileId = downloadResponseModel?.fileId;
            const fileName = commandResponse.fieldValues['FileName'];
            this.fileManagementService.downloadClientFileWithId(fileId).subscribe(payload => {
              this.fuseSplashScreenService.hide();
              this.fileManagementService.openSaveFileWindow(payload, fileName);
              this.snackBarService.showInformation('File Downloaded');
            });
          }
          if (commandResponse.fieldValues['RedirectCommand']) {
            this.executeCommand(commandResponse.fieldValues['RedirectCommand']);
            return;
          }
          if (commandResponse.fieldValues['RedirectUrl']) {
            this.router.navigateByUrl(commandResponse.fieldValues['RedirectUrl']);
          }
          this.fuseSplashScreenService.hide();
          if (commandResponse.fieldValues['PlatformLinkModel']) {
            this.magicLinkModel = commandResponse.fieldValues['PlatformLinkModel'];
            this.magicLinkModelValueChangedHandler({
              id: 'PlatformToolContainerComponent',
              value: commandResponse.fieldValues['PlatformLinkModel']
            });
          }
          if (commandResponse.fieldValues['Invalidate']) {
            this.invalidateSubject.invalidate();
          }
        },
        error => {
          this.fuseSplashScreenService.hide();
        });
    }
  }

  setSelectedTab(selectedTab: TabModel): void {
  }

  valueChanged($event) {
    console.log('Inside Handler', $event);
    if (this.handleAction($event)) {
      return;
    }
    if (this.handleCommand($event)) {
      return;
    }
  }
  private handleAction($event): boolean {
    console.log('Inside handleAction');
    if ($event && $event.action) {
      switch ($event.action?.id) {
        case 'duplicate':
          const duplicateCommand = this.getActionCommand($event.action.id);
          if (duplicateCommand) {
            duplicateCommand.fieldValues['SelectedSchemaId'] = $event?.item?.id;
            this.executeCommand(duplicateCommand);
            return true;
          }
          break;
        case 'delete':
        case 'download':
          const deleteCommand = this.getActionCommand($event.action.id);
          if (deleteCommand) {
            deleteCommand.fieldValues['SchemaId'] = $event?.item?.id;
            this.executeCommand(deleteCommand);
            return true;
          }
          break;
        default:
          break;
      }
    }
    return false;
  }
  private getActionCommand(actionId: string){
    const command = this.magicLinkModel.additionalCommands[actionId];
    return command;
  }
  private handleCommand($event): boolean {
    if ($event.name && $event.api) {
      const command = $event;
      if (command) {
        this.executeCommand(command);
      }
    }
    return false;
  }
  private magicLinkModelValueChangedHandler(command: any) {
    this.magicLinkModelValueChanged.emit(command);
  }
}
